import React, { FC } from 'react'
import { observer } from 'mobx-react'
// import { Img } from '@cps'
import { storeMobx } from '@mobxStore'
import './index.scss'
import themeMobx from '@mobx/app/theme.mobx'

// interface
interface IProps {
}

const BrandHeader: FC<IProps> = ({ }) => {
  // 头图url
  const brandHeaderUrl = themeMobx.data.brandHeaderUrl
  return (
    <>
      {
        !!brandHeaderUrl && (
          <div className='brand-header'>
            <img
              src={brandHeaderUrl}
            />
          </div>
        )
      }
    </>
  )
}

export default observer(BrandHeader)
